import React, { useState, useEffect } from 'react';
import ContratoEditor from './ContratoEditor';
import { connect } from 'react-redux';
import {
  getAllByParent,
  setPending,
  deleted,
} from '../redux/actions/contratoActions';
import { get as getParent } from '../redux/actions/alquilerPropietarioActions';
import { callStatus } from '../utils/constants';
import { Button, Space, Menu, Dropdown, Row, Col, Layout, Modal } from 'antd';
import { withRouter } from 'react-router-dom';
import { useHistory } from 'react-router-dom';

import {
  EditFilled,
  DeleteFilled,
  PlusCircleOutlined,
  UnorderedListOutlined,
  FormatPainterFilled,
  ExclamationCircleOutlined,
} from '@ant-design/icons';
import styled from 'styled-components';
import BaseBox from './base/BaseBox';
import MetaTable from './base/MetaTable';
import dayjs from 'dayjs';
import moment from 'moment';
import { convertDate } from '../utils/funtions';
import CustomCellRender from './base/CustomCellRender';
const { confirm } = Modal;

const { Content, Header, Footer } = Layout;

const SelectedContainer = styled.div`
  flex: 1;
`;

const ActionsContainer = styled.div``;

const FooterContainer = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  padding-top: 10px;
`;

const MenuButton = styled(Button)`
  width: 100%;
  text-align: left;
`;
const ContratoList = ({
  location,
  stateData,
  inversor,
  formaPagoContrato,
  dispatch,
  match: {
    params: { id, id2 },
  },
  parent,
}) => {
  const [view, setView] = useState(1);

  const [showEdit, setShowEdit] = useState(false);
  const [rowEdit, setRowEdit] = useState(null);
  const history = useHistory();

  const [dataSource, setDataSource] = useState([]);

  const formatDisplay = 'DD/MM/YYYY';
  useEffect(() => {
    dispatch(getAllByParent(id2));
    dispatch(getParent(id2));
    dispatch(setPending());
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (stateData.list.status === callStatus.LIST_SUCCESS) {
      const data = [
        ...stateData.list.data.map((item) => {
          return {
            ...item,
            fecha: dayjs(
              new Date(moment(moment(convertDate(item.fecha)))).toISOString()
            ).format(formatDisplay),
          };
        }),
      ];

      setDataSource(data);
    }

    // eslint-disable-next-line
  }, [stateData]);

  const handleEdit = (data) => {
    setRowEdit(data);
    setShowEdit(true);
  };

  const handleDelete = (data) => {
    dispatch(deleted(data.id));
  };

  const handleHideEditor = () => {
    setShowEdit(false);
    setRowEdit(null);
    dispatch(setPending());
  };

  const handleConfirm = (item) => {
    confirm({
      title: 'Esta a punto de eliminar un registro, desea continuar?',
      icon: <ExclamationCircleOutlined />,
      okText: 'Si',
      cancelText: 'No',
      autoFocusButton: 'cancel',
      onOk() {
        handleDelete(item);
      },
      onCancel() {},
    });
  };

  const handleCuotas = (data) => {
    history.push(
      `/campanas/alquileres/${id}/contratos/${id2}/contrato-cuotas/${data.id}`
    );
  };

  const columns = [
    {
      title: '',
      key: 'action',
      render: (text, record) => (
        <Space size="middle">
          <EditFilled onClick={(e) => handleEdit(record)} />
          <DeleteFilled onClick={(e) => handleConfirm(record)} />
        </Space>
      ),
      width: 60,
    },
    {
      width: 100,
      ellipsis: true,
      title: 'Fecha',
      dataIndex: 'fecha',
    },

    {
      width: 200,
      ellipsis: true,
      title: 'Modalidad Pago',
      dataIndex: 'forma_pago_nombre',
      onFilter: (value, record) => {
        return record.forma_pago_id === value;
      },
      sorter: (a, b) => a.forma_pago_nombre.localeCompare(b.forma_pago_nombre),
      filterMultiple: true,
      filters: formaPagoContrato.list.data.map((value) => {
        value['value'] = value.id;
        value['text'] = value.nombre;
        return value;
      }),
    },
    {
      width: 150,
      ellipsis: true,
      title: 'Superficie Ha',
      dataIndex: 'superficie',
      render: (text) => (
        <CustomCellRender text={text} justify={'space-between'} prefix={''} />
      ),
    },
    {
      width: 150,
      ellipsis: true,
      title: 'Toneladas',
      dataIndex: 'toneladas',
      render: (text) => (
        <CustomCellRender text={text} justify={'space-between'} prefix={''} />
      ),
    },
    {
      width: 150,
      ellipsis: true,
      title: 'Toneladas Totales',
      dataIndex: 'toneladas_total',
      render: (text) => (
        <CustomCellRender text={text} justify={'space-between'} prefix={''} />
      ),
    },
    {
      width: 150,
      ellipsis: true,
      title: 'Importe U$D',
      dataIndex: 'importe',
      render: (text) => (
        <CustomCellRender text={text} justify={'space-between'} prefix={''} />
      ),
    },
    {
      width: 200,
      ellipsis: true,
      title: 'Inversor',
      dataIndex: 'inversor_nombre',
      onFilter: (value, record) => {
        return record.inversor_id === value;
      },
      sorter: (a, b) => a.inversor_nombre.localeCompare(b.inversor_nombre),
      filterMultiple: true,
      filters: inversor.list.data.map((value) => {
        value['value'] = value.id;
        value['text'] = value.nombre;
        return value;
      }),
    },
    {
      title: '',
      key: 'action',
      render: (text, record) => (
        <Space size="middle">
          <Button onClick={(e) => handleCuotas(record)}>Cuotas</Button>
        </Space>
      ),
      width: 100,
    },
  ];

  const grid = { xs: 24, sm: 12, md: 12, lg: 8, xl: 8 };

  const menuView = (
    <Menu>
      <Menu.Item key="1">
        <MenuButton onClick={() => setView(1)} icon={<UnorderedListOutlined />}>
          Tabla
        </MenuButton>
      </Menu.Item>
      <Menu.Item key="2">
        <MenuButton onClick={() => setView(2)} icon={<UnorderedListOutlined />}>
          Box
        </MenuButton>
      </Menu.Item>
    </Menu>
  );

  return (
    <Layout style={{ height: '100%' }}>
      <Header
        style={{
          display: 'flex',
          justifyContent: 'flex-start',
          marginTop: '5px',
        }}
      >
        {parent.object.status === callStatus.OBJECT_SUCCESS && (
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              height: '100%',
            }}
          >
            <div
              style={{
                height: '17px',
              }}
            >
              <b>Campaña: </b>
              {parent.object.data.alquiler.campana.nombre}
            </div>

            <div
              style={{
                height: '17px',
              }}
            >
              <b>Alquiler: </b>
              {`${parent.object.data.propietario.nombre} - Superficie: ${parent.object.data.superficie} HA`}
            </div>
          </div>
        )}
      </Header>
      <Content>
        {view === 1 ? (
          <MetaTable
            dataSource={dataSource}
            dataColumns={columns}
            bordered={false}
            selection={false}
            loading={stateData.list.status === callStatus.LIST_IN_PROCESS}
          />
        ) : (
          <Row gutter={8}>
            {stateData.list.data.map((item) => {
              return (
                <Col {...grid} key={item.id} style={{ marginBottom: '10px' }}>
                  <BaseBox
                    handleEdit={handleEdit}
                    handleDelete={handleDelete}
                    item={item}
                    title={item.establecimiento_nombre}
                    subtitle={item.cultivo_nombre}
                    moreInfo={item.campana}
                  />
                </Col>
              );
            })}
          </Row>
        )}
      </Content>
      <Footer>
        <FooterContainer>
          <SelectedContainer></SelectedContainer>
          <ActionsContainer>
            <Button
              type="primary"
              icon={<PlusCircleOutlined />}
              size="small"
              onClick={(e) => handleEdit({})}
            >
              Agregar
            </Button>

            <Dropdown overlay={menuView}>
              <Button
                type="primary"
                icon={<FormatPainterFilled />}
                size="small"
                style={{ marginLeft: '3px' }}
              >
                Vista
              </Button>
            </Dropdown>
          </ActionsContainer>
        </FooterContainer>
      </Footer>
      {showEdit ? (
        <ContratoEditor
          id={rowEdit.id}
          parentId={id2}
          onCancel={handleHideEditor}
          visible={true}
        />
      ) : (
        false
      )}
    </Layout>
  );
};

const mapStateToProps = (state) => {
  const { contrato, inversor, formaPagoContrato, alquilerPropietario } = state;
  const stateData = contrato;
  const parent = alquilerPropietario;

  return {
    stateData,
    inversor,
    formaPagoContrato,
    parent,
  };
};
export default connect(mapStateToProps)(withRouter(ContratoList));
